export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const combined = `${error.name}\n${error.message}\n${error.stack ?? ""}`;

  return (
    error.name === "ChunkLoadError" ||
    /loading chunk/i.test(combined) ||
    /failed to fetch dynamically imported module/i.test(combined) ||
    /importing a module script failed/i.test(combined)
  );
}
